// All target browsers support `Object.fromEntries`, but not all of our
// node versions do which causes problems in CI. This function exists
// as a simple workaround.
export const fromEntries = (entries: Array<[string, any]>) => {
  return entries.reduce((obj: { [key: string]: any }, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});
};
